import React, { useState, useRef, useEffect } from "react";
import { FaBell, FaAngleDown, FaAngleUp, FaCheck } from "react-icons/fa";

export const AccountDropdown = ({ accounts = [], selectedAccounts = [], onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Normalize accounts list to array of string names sorted alphabetically
  const accountList = accounts
    .map((acc) => (typeof acc === "object" ? acc.account_no : acc))
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b));

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isAllSelected =
    accountList.length > 0 && selectedAccounts.length === accountList.length;

  const handleToggleAll = () => {
    if (isAllSelected) {
      onChange([]);
    } else {
      onChange([...accountList]);
    }
  };

  const handleToggleAccount = (accNo) => {
    if (selectedAccounts.includes(accNo)) {
      onChange(selectedAccounts.filter((a) => a !== accNo));
    } else {
      onChange([...selectedAccounts, accNo]);
    }
  };

  const labelText =
    selectedAccounts.length === 0
      ? "0 selected"
      : isAllSelected
      ? "All selected"
      : `${selectedAccounts.length} selected`;

  return (
    <div className="account-dropdown-wrapper" ref={dropdownRef}>
      <button
        type="button"
        className="account-dropdown-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FaBell className="bell-icon" />
        <span className="trigger-text">{labelText}</span>
        {isOpen ? <FaAngleUp className="arrow-icon" /> : <FaAngleDown className="arrow-icon" />}
      </button>

      {isOpen && (
        <div className="account-dropdown-menu">
          <div
            className={`account-dropdown-item ${isAllSelected ? "selected" : ""}`}
            onClick={handleToggleAll}
          >
            <div className="checkbox-custom">
              {isAllSelected && <FaCheck className="check-icon" />}
            </div>
            <span>Select All</span>
          </div>

          {accountList.map((accNo) => {
            const isSelected = selectedAccounts.includes(accNo);
            return (
              <div
                key={accNo}
                className={`account-dropdown-item ${isSelected ? "selected" : ""}`}
                onClick={() => handleToggleAccount(accNo)}
              >
                <div className="checkbox-custom">
                  {isSelected && <FaCheck className="check-icon" />}
                </div>
                <span>{accNo}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AccountDropdown;
